import type { AlgorithmType } from "../redistribution/models/AlgorithmType.ts";
import { isDemandSourceType } from "../redistribution/models/DemandSourceType.ts";
import { useAppStore } from "../stores/app.ts";
import { fetchRedistributionSettings } from "./apiClient.ts";

function isAlgorithmType(value: string): value is AlgorithmType {
  return value === "BruteForce" || value === "Milp";
}

/**
 * Sets Algorithm and Demand dropdown defaults from GET redistribution-settings.
 * Failures leave hardcoded store defaults in place.
 */
export async function applyConfiguredRedistributionDefaults(): Promise<void> {
  const settings = await fetchRedistributionSettings();
  if (!settings) {
    return;
  }

  const store = useAppStore();

  if (isAlgorithmType(settings.defaultAlgorithm)) {
    store.algorithmType = settings.defaultAlgorithm;
  }

  if (isDemandSourceType(settings.defaultDemandSource)) {
    store.demandSource = settings.defaultDemandSource;
  }

  if (settings.availableDemandSources.length > 0) {
    store.setAvailableDemandSources(settings.availableDemandSources);
  }
}
